/// <reference path="../../../../../shared/models/generated/FahrzeugdatenModelleErgebnisApi.d.ts"/>
/// <reference path="../../../../../shared/models/generated/FahrzeugkeyBaureiheGenerationenWithKeyErgebnisApi.d.ts"/>
/// <reference path="../../../../../shared/models/generated/FahrzeugkeyHerstellerWithKeyErgebnisApi.d.ts"/>
/// <reference path="../../../../../shared/models/generated/FahrzeugkeyBaureihenWithKeyErgebnisApi.d.ts"/>
/// <reference path="../../../../../shared/models/generated/FahrzeugkeyModellVariantenWithKeyErgebnisApi.d.ts"/>
/// <reference path="../../../../../shared/models/generated/FahrzeugkeyFahrzeugeWithKeyErgebnisApi.d.ts"/>
/// <reference path="../../../../../shared/models/generated/FahrzeugkeyResolveTetKeyResponseApi.d.ts"/>
import { AppUtils } from '../../../../../shared/utils/index';
import { AppFormModel } from "../models/AppFormModel";
import { AppModelAdapter } from "../models/AppModelAdapter";
import { User } from "../../../../../shared/models/api/User/User";
import { BasicApplicationUrlBuilder } from "../../../../../shared/services/BasicApplicationUrlBuilder";
import { MeinFahrzeugDetailApi } from "../../../../../shared/models/generated/FahrzeugeMeinFahrzeugDetailApi";
import { FahrzeugDetailApi } from "../../../../../shared/models/apim/FahrzeugDetailApi";
import { FahrzeugModel } from "../../../../../shared/models/view/Fahrzeug";

export interface VehicleUpdateChanges { Marke: boolean, Baureihe: boolean, BaureiheGeneration: boolean, Modell: boolean }

export class AppApiService {
	private readonly options: BasicAppOptions<MyVehicleAppDefinition>;
	private readonly applicationUrlBuilder: BasicApplicationUrlBuilder<MyVehicleAppDefinition>;

	constructor(parent: StepController, options: BasicAppOptions<MyVehicleAppDefinition>) {
		this.options = options;
		this.applicationUrlBuilder = new BasicApplicationUrlBuilder(this.options);
	}

	/**
	 * api/Garage
	 */
	public submitRequest(formModel: AppFormModel, user: User,
		successCallback: (data: ApiResponse<MeinFahrzeugDetailApi>, textStatus?: JQuery.Ajax.SuccessTextStatus, jqxhr?: JQueryXHR) => void,
		errorCallback: (jqxhr: JQueryXHR, textStatus?: JQuery.Ajax.ErrorTextStatus, errorThrown?: string) => void): void {

		const modelApi = AppModelAdapter.getFahrzeugModelApi(formModel.Fahrzeug);
		// Is allways true. As the PO said.
		modelApi.Zustimmung = true;
		T.Utils.Auth.getBearerToken((token: string) => {
			const req: { [key: string]: any } = {
				method: 'POST',
				url: this.applicationUrlBuilder.fullUrl(this.options.app.apigarage),
				headers: { Authorization: `Bearer ${token}` },
				data: modelApi.toJsonString()
			};

			AppUtils.Ajax.fragment(req, successCallback, errorCallback);
		});
	}

	public getModels(apiUrl: string,
		successCallback: (data: ApiResponse<ModelleErgebnisApi>, textStatus?: JQuery.Ajax.SuccessTextStatus, jqxhr?: JQueryXHR) => void,
		errorCallback: (jqxhr: JQueryXHR, textStatus?: JQuery.Ajax.ErrorTextStatus, errorThrown?: string) => void): void {
		T.Utils.Auth.getBearerToken((token: string) => {
			AppUtils.Ajax.fragment({
				method: 'GET',
				url: apiUrl,
				headers: { Authorization: `Bearer ${token}` }
			}, successCallback, errorCallback);
		});
	}

	public getVehicles(vehicleId: string,
		successCallback: (fahrzeugModel: AppFormModel, textStatus?: JQuery.Ajax.SuccessTextStatus, jqhxr?: JQueryXHR) => void,
		errorCallback: (jqxhr?: JQueryXHR, textStatus?: JQuery.Ajax.ErrorTextStatus, errorThrown?: string) => void): void {
		const formModel = new AppFormModel();
		T.Utils.Auth.getBearerToken((token: string) => {
			AppUtils.Ajax.fragment({
				method: 'GET',
				url: this.applicationUrlBuilder.fullUrl(`${this.options.app.apigarage}/${vehicleId}`),
				headers: { Authorization: `Bearer ${token}` }
			}, (data: ApiResponse<MeinFahrzeugDetailApi[]>) => {
				formModel.Fahrzeug = AppModelAdapter.getFahrzeugModel(data.Data[0]);
				formModel.Fahrzeug.ID = vehicleId;
				successCallback(formModel);
			}, errorCallback);
		});

	}

	public getFahrzeugDetails(kfzId: string, formModel: AppFormModel,
		successCallback: (fahrzeugModel: AppFormModel, textStatus?: JQuery.Ajax.SuccessTextStatus, jqhxr?: JQueryXHR) => void,
		errorCallback: (jqxhr?: JQueryXHR, textStatus?: JQuery.Ajax.ErrorTextStatus, errorThrown?: string) => void): void {

		AppUtils.Ajax.fragment({
			method: 'GET',
			url: this.applicationUrlBuilder.fullApimUrl(`${this.options.app.apifahrzeugdetails}/${kfzId}`),
			headers: {
				"Ocp-Apim-Subscription-Key": T.Utils.Application.apimSubscriptionKey
			}
		}, (data: ApiResponse<FahrzeugDetailApi>) => {
			AppModelAdapter.updateFahrzeugFormModel(data.Data, formModel);
			successCallback(formModel);
		}, errorCallback);

	}

	public submitDeleteRequest(vehicleId: string,
		successCallback: (data: ApiResponse<null>, textStatus?: JQuery.Ajax.SuccessTextStatus, jqhxr?: JQueryXHR) => void,
		errorCallback: (jqxhr?: JQueryXHR, textStatus?: JQuery.Ajax.ErrorTextStatus, errorThrown?: string) => void): void {
		T.Utils.Auth.getBearerToken((token: string) => {
			AppUtils.Ajax.fragment({
				method: 'DELETE',
				url: this.applicationUrlBuilder.fullUrl(`${this.options.app.apigarage}/${vehicleId}`),
				headers: { Authorization: `Bearer ${token}` }
			}, successCallback, errorCallback);
		});
	}


	public getMarke(formModel: AppFormModel,
		successCallback: (data: HerstellerWithKeyErgebnisApi, textStatus?: JQuery.Ajax.SuccessTextStatus, jqxhr?: JQueryXHR) => void,
		errorCallback: (jqxhr: JQueryXHR, textStatus?: JQuery.Ajax.ErrorTextStatus, errorThrown?: string) => void): void {
		const params = {
			searchname: formModel.Fahrzeug.Marke,
			Status: AppModelAdapter.getDefaultMarkenStatus(),
			Repository: AppModelAdapter.getFahrzeugdatenRepository(formModel.Fahrzeug)
		};

		const url = AppUtils.Url.updateUrlParameter(params, this.options.app.apibrandsv2);

		AppUtils.Ajax.fragment({
			method: 'GET',
			url: url
		}, (data: ApiResponse<HerstellerWithKeyErgebnisApi>) => {
			if (data.Success && data.Data && data.Data.Anzahl) {
				successCallback(data.Data);
			} else {
				errorCallback(null);
			}

		}, errorCallback);

	}

	public getBaureiheId(formModel: AppFormModel,
		successCallback: (data: BaureihenWithKeyErgebnisApi, textStatus?: JQuery.Ajax.SuccessTextStatus, jqxhr?: JQueryXHR) => void,
		errorCallback: (jqxhr: JQueryXHR, textStatus?: JQuery.Ajax.ErrorTextStatus, errorThrown?: string) => void): void {

		const params = {
			Brand: formModel.Fahrzeug.Marke,
			BrandId: formModel.Fahrzeug.MarkeId,
			searchname: '',
			Status: AppModelAdapter.getDefaultMarkenStatus(),
			Repository: AppModelAdapter.getFahrzeugdatenRepository(formModel.Fahrzeug)
		};

		if (formModel.Fahrzeug.Baureihe) {
			params.searchname = formModel.Fahrzeug.Baureihe.replace(/'/g, '"');
		}
		const url = AppUtils.Url.updateUrlParameter(params, this.options.app.apiseriesv2);

		AppUtils.Ajax.fragment({
			method: 'GET',
			url: url
		}, (data: ApiResponse<BaureihenWithKeyErgebnisApi>) => {
			if (data.Success && data.Data && data.Data.Anzahl) {
				successCallback(data.Data);
			} else {
				errorCallback(null);
			}
		}, errorCallback);
	}



	public getBaureihenGenerationenSelections(formModel: AppFormModel,
		successCallback: (data: BaureiheGenerationenWithKeyErgebnisApi, textStatus?: JQuery.Ajax.SuccessTextStatus, jqxhr?: JQueryXHR) => void,
		errorCallback: (jqxhr: JQueryXHR, textStatus?: JQuery.Ajax.ErrorTextStatus, errorThrown?: string) => void): void {

		const params = {
			seriesId: formModel.Fahrzeug.BaureiheId,
			series: formModel.Fahrzeug.Baureihe.replace(/'/g, '"'),
			Status: AppModelAdapter.getDefaultMarkenStatus(),
			Repository: AppModelAdapter.getFahrzeugdatenRepository(formModel.Fahrzeug)
		};
		const url = AppUtils.Url.updateUrlParameter(params, this.options.app.apibuildinggenerationv2);

		AppUtils.Ajax.fragment({
			method: 'GET',
			url: url
		}, (data: ApiResponse<BaureiheGenerationenWithKeyErgebnisApi>) => {
			if (data.Success && data.Data) {
				successCallback(data.Data);
			} else {
				errorCallback(null);
			}
		}, errorCallback);
	}

	public getModellVariantenSelections(formModel: AppFormModel,
		successCallback: (data: ModellVariantenWithKeyErgebnisApi, textStatus?: JQuery.Ajax.SuccessTextStatus, jqxhr?: JQueryXHR) => void,
		errorCallback: (jqxhr: JQueryXHR, textStatus?: JQuery.Ajax.ErrorTextStatus, errorThrown?: string) => void): void {

		const params = {
			buildingGenerationId: formModel.Fahrzeug.BaureiheGenerationId,
			buildinggeneration: '',
			Status: AppModelAdapter.getDefaultMarkenStatus(),
			Repository: AppModelAdapter.getFahrzeugdatenRepository(formModel.Fahrzeug)
		};
		const url = AppUtils.Url.updateUrlParameter(params, this.options.app.apimodelvariantsv2);

		AppUtils.Ajax.fragment({
			method: 'GET',
			url: url
		}, (data: ApiResponse<ModellVariantenWithKeyErgebnisApi>) => {
			if (data.Success && data.Data) {
				successCallback(data.Data);
			} else {
				errorCallback(null);
			}
		}, errorCallback);
	}

	public getVehicleSelection(formModel: AppFormModel,
		successCallback: (data: FahrzeugeWithKeyErgebnisApi, textStatus?: JQuery.Ajax.SuccessTextStatus, jqxhr?: JQueryXHR) => void,
		errorCallback: (jqxhr: JQueryXHR, textStatus?: JQuery.Ajax.ErrorTextStatus, errorThrown?: string) => void): void {

		const params = {
			modelvariantId: formModel.Fahrzeug.ModellId,
			modelvariant: '',
			Status: AppModelAdapter.getDefaultMarkenStatus(),
			Repository: AppModelAdapter.getFahrzeugdatenRepository(formModel.Fahrzeug)
		};

		const url = AppUtils.Url.updateUrlParameter(params, this.options.app.apivehiclev2);

		AppUtils.Ajax.fragment({
			method: 'GET',
			url: url
		}, (data: ApiResponse<FahrzeugeWithKeyErgebnisApi>) => {
			if (data.Success && data.Data) {
				successCallback(data.Data);
			} else {
				errorCallback(null);
			}
		}, errorCallback);
	}

	public updateVehicleDetailIds(vehicleModel: FahrzeugModel,
		successCallback: (changedFields: VehicleUpdateChanges, vehicleModel: FahrzeugModel) => void,
		errorCallback: (errorSource: string, changedFields: VehicleUpdateChanges, jqxhr?: JQueryXHR) => void): void {

		const changes = {
			Marke: false,
			Baureihe: false,
			BaureiheGeneration: false,
			Modell: false
		};
		if (!vehicleModel.TetId) {
			errorCallback("TetId", changes);
			return;
		}
		if (vehicleModel.Marke && vehicleModel.MarkeId && vehicleModel.Baureihe && vehicleModel.BaureiheId
			&& vehicleModel.BaureiheGeneration && vehicleModel.BaureiheGenerationId && vehicleModel.Modell && vehicleModel.ModellId) {
			successCallback(changes, vehicleModel);
			return;
		}

		AppUtils.Ajax.fragment({
			method: 'GET',
			url: this.options.app.apitetkeyresolution,
			data: {
				tetSchluessel: vehicleModel.TetId
			}
		}, (data: ApiResponse<ResolveTetKeyResponseApi>) => {
			if (data.Success && data.Data) {
				if (data.Data.Marke) {
					vehicleModel.Marke = data.Data.Marke;
				}
				if (data.Data.MarkeId) {
					vehicleModel.MarkeId = data.Data.MarkeId.toString();
				}
				changes.Marke = !!data.Data.Marke || !!data.Data.MarkeId;

				if (data.Data.Baureihe) {
					vehicleModel.Baureihe = data.Data.Baureihe;
				}
				if (data.Data.BaureiheId) {
					vehicleModel.BaureiheId = data.Data.BaureiheId.toString();
				}
				changes.Baureihe = !!data.Data.Baureihe || !!data.Data.BaureiheId;

				if (data.Data.Baureihengeneration) {
					vehicleModel.BaureiheGeneration = data.Data.Baureihengeneration;
				}
				if (data.Data.BaureihengenerationId) {
					vehicleModel.BaureiheGenerationId = data.Data.BaureihengenerationId.toString();
				}
				changes.BaureiheGeneration = !!data.Data.Baureihengeneration || !!data.Data.BaureihengenerationId;

				if (data.Data.Modellvariante) {
					vehicleModel.Modell = data.Data.Modellvariante;
				}
				if (data.Data.ModellvarianteId) {
					vehicleModel.ModellId = data.Data.ModellvarianteId.toString();
				}
				changes.Modell = !!data.Data.Modellvariante || !!data.Data.ModellvarianteId;
				successCallback(changes, vehicleModel);
			} else {
				errorCallback('Marke', changes);
			}
		}, (jqxhr: JQueryXHR) => {
			errorCallback('Marke', changes, jqxhr);
		});
	}
}
